<ng-container *transloco="let t; read: 'companies'">
  <span class="roleTitle">{{ t('roleTitle') }}</span>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="flex flexDirCol">
    <div formArrayName="userRoles" class="mbs">
      @for (userRole of userRolesArray.controls; track userRole; let i = $index) {
        <div>
          <div [formGroupName]="i" class="roleItem">
            <input
              type="checkbox"
              kendoCheckBox
              formControlName="enabled"
              [value]="userRole.enabled"/>
              <span class="roleItemText">{{t('roles.' + userRole.get('roleName').value + '.name')}}</span>
              <span class="roleItemDesc"> ({{t('roles.' + userRole.get('roleName').value + '.description')}})</span>
            </div>
          </div>
        }
      </div>
      <button
        kendoButton
        class="buttonPrimary"
        type="submit"
        [disabled]="!form?.dirty"
        >
        Speichern
      </button>
    </form>
  </ng-container>
